<div class="sequential-divergent-color-picker-container">
  <div class="label-container" [class.sequential]="!isDivergent" [class.divergent]="isDivergent">
    <ng-container
      *ngTemplateOutlet="
        gradientLabel;
        context: { value: labels?.min?.label ?? '', className: 'min-label', isAuto: labels?.min?.isAuto ?? false }
      "
    ></ng-container>
    <ng-container *ngIf="isDivergent">
      <ng-container
        *ngTemplateOutlet="
          gradientLabel;
          context: { value: labels?.mid?.label ?? '', className: 'mid-label', isAuto: labels?.mid?.isAuto ?? false }
        "
      ></ng-container>
    </ng-container>
    <ng-container
      *ngTemplateOutlet="
        gradientLabel;
        context: { value: labels?.max?.label ?? '', className: 'max-label', isAuto: labels?.max?.isAuto ?? false }
      "
    ></ng-container>
  </div>

  <div *ngIf="hasSteps && !hideSteps" class="color-preview step-container">
    <ng-container *ngFor="let step of stepColors">
      <div class="step" [style.background]="step"></div>
    </ng-container>
  </div>

  <div *ngIf="!hasSteps || hideSteps" class="color-preview" [style.background]="background"></div>

  <div class="swatch-container">
    <mode-color-swatch-flyout
      [activeColor]="minColor"
      [selectedColorPalette]="flyoutDefaultPalette"
      [allColorPalettes]="allColorPalettes"
      [vizToken]="vizToken"
      (colorUpdated)="onColorChanged($event, 'min')"
    >
    </mode-color-swatch-flyout>
    <mode-color-swatch-flyout
      *ngIf="isDivergent"
      [activeColor]="midColor"
      [selectedColorPalette]="flyoutDefaultPalette"
      [allColorPalettes]="allColorPalettes"
      [vizToken]="vizToken"
      (colorUpdated)="onColorChanged($event, 'mid')"
    >
    </mode-color-swatch-flyout>
    <mode-color-swatch-flyout
      [activeColor]="maxColor"
      [selectedColorPalette]="flyoutDefaultPalette"
      [allColorPalettes]="allColorPalettes"
      [vizToken]="vizToken"
      (colorUpdated)="onColorChanged($event, 'max')"
    >
    </mode-color-swatch-flyout>
  </div>
  <div class="ui-controls-container">
    <div class="ui-button-container">
      <capra-icon-button
        *ngIf="!hideSteps"
        class="ui-button"
        icon="icon-granularity-back"
        data-test="remove-step-button"
        capraTooltip
        [tooltipContent]="isBinned ? 'Step controls are not available for binned fields' : 'Remove step'"
        tooltipPlacement="bottom"
        size="medium"
        [tooltipInteractive]="false"
        [tooltipDelay]="[500, 0]"
        [tooltipIsDisabled]="numberOfSteps === 0 && !isBinned"
        [disabled]="numberOfSteps === 0 || isBinned"
        (click)="removeStep()"
      ></capra-icon-button>
      <capra-icon-button
        *ngIf="!hideSteps"
        class="ui-button"
        icon="icon-granularity-forward"
        data-test="add-step-button"
        capraTooltip
        [tooltipContent]="isBinned ? 'Step controls are not available for binned fields' : 'Add step'"
        size="medium"
        tooltipPlacement="bottom"
        [tooltipInteractive]="false"
        [tooltipDelay]="[500, 0]"
        [tooltipIsDisabled]="numberOfSteps === 7 && !isBinned"
        [disabled]="numberOfSteps === 7 || isBinned"
        (click)="addStep()"
      ></capra-icon-button>
    </div>
    <div class="ui-button-container">
      <capra-icon-button
        class="ui-button"
        icon="icon-control-reverse"
        data-test="gradient-reverse-button"
        capraTooltip
        tooltipContent="Reverse colors"
        tooltipPlacement="bottom"
        [tooltipInteractive]="false"
        [tooltipDelay]="[500, 0]"
        (click)="reverseGradient()"
      ></capra-icon-button>
    </div>
  </div>
</div>
<ng-template #gradientLabel let-value="value" let-className="className" let-isAuto="isAuto">
  <div class="{{ className }}" *ngIf="!hideLabels">
    <span>{{ value }}</span>
    <span class="auto-label" *ngIf="isAuto && !hideAutoLabel">(Auto)</span>
  </div>
</ng-template>
